import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addFeelingApi, getFeelingByUserApi } from "../../Modules/Services/feeling";

export const addFeeling = createAsyncThunk(
    "feeling/add",
    async (values, { rejectWithValue }) => {
        try {
            const responese = await addFeelingApi(values);
            return responese;
        } catch (err) {
            if (err.code === "ERR_NETWORK");
            toast.error(
                err.message || "Network error. Please check your internet connection."
            );
            return rejectWithValue(err.message);
        }
    }
);
export const getFeelingByUserId = createAsyncThunk(
    "feeling/getFeelingByUserId",
    async ({ id, session_ID }, { rejectWithValue }) => {
        try {
            const responese = await getFeelingByUserApi(id, session_ID);
            return responese;
        } catch (err) {
            if (err.code === "ERR_NETWORK");
            toast.error(
                err.message || "Network error. Please check your internet connection."
            );
            return rejectWithValue(err.message);
        }
    }
);